$mol_view_tree2_to_js_test_ex_bidi_with_default_object_foo $mol_object
	class? <=> owner? $mol_object
